const APP_TITLE = 'Ticket Smile';
const PANEL_SUFFIX = 'Painel de controle';

const firstParam = (value) => Array.isArray(value) ? value[0] : value;

const cleanTitlePart = (value) => {
  if (!value) return '';
  return String(value).replace(/\s+/g, ' ').trim();
};

const getName = (payload, keys) => {
  if (!payload) return '';
  for (const key of keys) {
    const value = payload?.[key];
    if (value) return cleanTitlePart(value);
  }
  return '';
};

const getSectionLabel = (path) => {
  if (path.includes('/financeiro/vendas')) return 'Vendas';
  if (path.includes('/financeiro/extrato')) return 'Extrato financeiro';
  if (path.includes('/financeiro/saques')) return 'Saques';
  if (path.includes('/financeiro/historico')) return 'Historico financeiro';
  if (path.includes('/financeiro')) return 'Financeiro';
  if (path.includes('/ingressos/add')) return 'Novo ingresso';
  if (path.includes('/ingressos/editar')) return 'Editar ingresso';
  if (path.includes('/ingressos')) return 'Ingressos';
  if (path.includes('/participantes/email')) return 'E-mail para participantes';
  if (path.includes('/participantes')) return 'Participantes';
  if (path.includes('/checkin')) return 'Check-in';
  if (path.includes('/cupons/add')) return 'Novo cupom';
  if (path.includes('/cupons/editar')) return 'Editar cupom';
  if (path.includes('/cupons')) return 'Cupons';
  if (path.includes('/integracoes')) return 'Integracoes';
  if (path.includes('/preferencias')) return 'Preferencias';
  if (path.includes('/notificacoes')) return 'Notificacoes';
  if (path.includes('/config')) return 'Configuracoes';
  if (path.includes('/editar')) return 'Editar';
  if (path.includes('/produtos')) return 'Produtos';
  if (path.includes('/estoque')) return 'Estoque';
  if (path.includes('/pedidos')) return 'Pedidos';
  if (path.includes('/equipe')) return 'Equipe';
  if (path.includes('/nfc')) return 'Cartoes NFC';
  if (path.includes('/bares/add')) return 'Novo bar';
  if (path.includes('/bares')) return 'Bares';
  if (path.includes('/eventos/add')) return 'Novo evento';
  if (path.includes('/eventos')) return 'Eventos';
  if (path.includes('/locais/add')) return 'Novo local';
  if (path.includes('/locais')) return 'Locais';
  if (path.includes('/comunicacao')) return 'Comunicacao';
  if (path.includes('/suporte/')) return 'Suporte';
  if (path.includes('/suporte')) return 'Suporte';
  return PANEL_SUFFIX;
};

export const usePanelPageTitle = async () => {
  const route = useRoute();
  const config = useRuntimeConfig();
  const token = useCookie('token');
  const baseUrl = config.public.NUXT_API_BACK_URL;

  const apiGet = async (path) => {
    if (!token.value || !baseUrl) return null;
    try {
      return await $fetch(`${baseUrl}${path}`, {
        headers: { Authorization: `Bearer ${token.value}` },
      });
    } catch {
      return null;
    }
  };

  const { data: context } = await useAsyncData(
    `panel-title-${route.fullPath}`,
    async () => {
      const orgId = firstParam(route.params.id);
      const eventId = firstParam(route.params.id_evento);
      const barId = firstParam(route.params.id_bar);

      const [org, event, bar] = await Promise.all([
        orgId ? apiGet(`/organizador/${orgId}`) : null,
        eventId ? apiGet(`/eventos/unico/${eventId}`) : null,
        barId ? apiGet(`/bars/${barId}`) : null,
      ]);

      return { org, event, bar };
    },
    { watch: [() => route.fullPath, token] }
  );

  const title = computed(() => {
    const path = route.path;
    const section = getSectionLabel(path);
    const orgName = getName(context.value?.org, ['nome', 'name', 'titulo']);
    const eventName = getName(context.value?.event, ['titulo', 'nome', 'name']);
    const barName = getName(context.value?.bar?.bar || context.value?.bar, ['nome', 'name', 'titulo']);

    if (path.includes('/bar/') && barName) {
      return `Bar - ${barName} / ${APP_TITLE} - ${section}`;
    }

    if (path.includes('/evento/') && eventName) {
      return `${eventName} - ${APP_TITLE} - ${section}`;
    }

    if (path.includes('/org/') && orgName) {
      return `${orgName} - ${APP_TITLE} - ${section}`;
    }

    if (path.includes('/financeiro')) {
      return `Financeiro - ${APP_TITLE} - ${section}`;
    }

    if (path === '/painel') {
      return `${APP_TITLE} - ${PANEL_SUFFIX}`;
    }

    return `${section} - ${APP_TITLE} - ${PANEL_SUFFIX}`;
  });

  return title;
};
